module.exports = __webpack_public_path__ + "img/e-kapusta.3d9fc92d.svg";